module.exports = __webpack_public_path__ + "static/media/unlike.a12d5a4c.svg";